import { MediaPlayerSettingClass } from "dashjs";

export const DASH_PLAYER_SETTINGS: MediaPlayerSettingClass = {
  errors: {
    recoverAttempts: {
      mediaErrorDecode: Infinity,
    },
  },
  streaming: {
    wallclockTimeUpdateInterval: 100,
    retryAttempts: {
      MPD: Infinity,
      MediaSegment: Infinity,
      FragmentInfoSegment: Infinity,
      InitializationSegment: Infinity,
      other: Infinity,
      IndexSegment: Infinity,
    },
    retryIntervals: {
      MPD: 1000,
      MediaSegment: 1000,
      FragmentInfoSegment: 1000,
      InitializationSegment: 1000,
      other: 1000,
      IndexSegment: 1000,
    },
    liveCatchup: {
      maxDrift: 5,
      enabled: true,
    },
    gaps: {
      jumpGaps: true,
      jumpLargeGaps: true,
      enableSeekFix: true,
    },
    timeShiftBuffer: {
      calcFromSegmentTimeline: true,
      fallbackToSegmentTimeline: true,
    },
    enableManifestDurationMismatchFix: false,
  },
};
